<template>
  <div class="wrapper">
    <div class="look-nav" style="justify-content: flex-start">
      <div class="input-date-wrapper">
        <el-date-picker
          v-model="value"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
      </div>
      <DropDown content="请选择日志类型" :items="type" v-on:sendInfo = "showInfo"></DropDown>
      <div class="input-wrapper" style="margin-left: 1vw">
        <input v-model="tableItem.userName" placeholder="请输入用户名称"/>
      </div>
      <div class="input-wrapper">
        <input v-model="tableItem.ipAddress" placeholder="请输入IP地址"/>
      </div>
      <div class="query button" @click="handleSearch(1)">查询</div>
    </div>
    <div class="detail">
      <div class="detail-box">
        <div class="loading-data" v-if="loading">
          <i class="el-icon-loading"></i>
          <div>加载中，请稍后···</div>
        </div>
        <div class="detail-nav">
          <div class="detail-item" style="width: 5%">序号</div>
          <div class="detail-item" style="width: 15%">用户名称</div>
          <div class="detail-item" style="width: 15%">时间</div>
          <div class="detail-item" style="width: 15%">IP地址</div>
          <div class="detail-item" style="width: 20%">IP所在地</div>
          <div class="detail-item" style="width: 15%">日志类型</div>
          <div class="detail-item" style="width: 15%">备注</div>
        </div>
        <div class="detail-content">
          <div class="detail-list-wrapper" v-if="!loading && tableData.length>0" v-for="(data,index) in tableData" :key="index">
            <div class="detail-item" style="width: 5%">{{index+1}}</div>
            <div class="detail-item" style="width: 15%">{{data.userName}}</div>
            <div class="detail-item" style="width: 15%">{{data.createdTime}}</div>
            <div class="detail-item" style="width: 15%">{{data.ipAddress}}</div>
            <div class="detail-item" style="width: 20%">{{data.ipLocation}}</div>
            <div class="detail-item" style="width: 15%">{{data.logTypeName}}</div>
            <div class="detail-item" style="width: 15%">
              <el-popover
                placement="left"
                title=""
                trigger="hover"
                :content="data.remark">
                <div class="popover" slot="reference">{{data.remark}}</div>
              </el-popover>
            </div>
          </div>
          <div class="none-data" v-if="!loading && tableData.length<1">暂无数据</div>
        </div>
        <div class="page-wrapper" v-if="!loading && total > rows">
          <div class="page-wrapper-left">共{{total}}条数据，每页显示{{rows}}条，当前第{{page}}页</div>
          <div class="page-wrapper-right">
            <div class="page-btn" @click="firstPage">首页</div>
            <div class="page-btn" @click="previousPage">上一页</div>
            <div class="page-btn" @click="nextPage">下一页</div>
            <div class="page-btn" @click="lastPage">尾页</div>
          </div>
        </div>
      </div>
    </div>
    <img class="wrapper-icon" src="../../../assets/content-box.png"/>
  </div>
</template>

<script>
import DropDown from '../../../components/DropDownSingle.vue'
import {queryNodeHistoryInfo} from '../../../api/basic'
import {renderTime} from '../../../tools/methods'
export default {
  name: 'Log',
  components: { DropDown },
  data () {
    return {
      value: '',
      type: [
        {name: '全部', value: ''},
        {name: '登录操作', value: 2},
        {name: '删除操作', value: 8},
        {name: '登出操作', value: 32}
      ],
      tableItem: {
        endTime: '',
        ipAddress: '',
        logType: '',
        page: '',
        rows: '',
        startTime: '',
        userName: ''
      },
      loading: true,
      page: 1,
      rows: 12,
      total: '',
      tableData: []
    }
  },
  watch: {
    value: function () {
      console.log(this.value)
      this.tableItem.startTime = this.value !== null ? this.value[0] : ''
      this.tableItem.endTime = this.value !== null ? this.value[1] : ''
    }
  },
  created () {
    this.handleSearch(1)
  },
  methods: {
    showInfo: function (data) {
      console.log(data)
      this.tableItem.logType = data.value
    },
    handleSearch: function (click) {
      if (click === 1) {
        this.page = 1
      }
      this.loading = true
      this.tableItem.page = this.page
      this.tableItem.rows = this.rows
      let body = this.tableItem
      queryNodeHistoryInfo(body).then(res => {
        res.data.rows.map(item => {
          item.createdTime = renderTime(item.createdTime)
        })
        console.log(res)
        this.tableData = res.data.rows || []
        this.total = res.data.total
        this.loading = false
        this.all = false
        this.idList = []
      }).catch(err => {
        console.log(err)
      })
    },
    firstPage: function () {
      console.log('首页')
      if (this.page === 1) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page = 1
        this.handleSearch()
      }
    },
    previousPage: function () {
      console.log('上一页')
      if (this.page < 2) {
        this.$message({
          message: '当前为第一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        this.page--
        this.handleSearch()
      }
    },
    nextPage: function () {
      console.log('下一页')
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++
        this.handleSearch()
      } else {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      }
    },
    lastPage: function () {
      console.log('尾页')
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: '当前为最后一页',
          type: 'warning',
          center: 'true',
          duration: '1000'
        })
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows)
        } else {
          this.page = parseInt(this.total / this.rows) + 1
        }
        this.handleSearch()
      }
    }
  }
}
</script>

<style scoped>
@import "./Log.css";
</style>



// WEBPACK FOOTER //
// src/page/basic/log/Log.vue